document.addEventListener('alpine:init', () => {
    Alpine.data('PostLoop', () => ({
        loopId: null,
        init() {
            this.loopId = this.$el.dataset.postLoopId;
            this.getPostData();
        },

        getPostData() {
            const data = new FormData();
            data.append('action', 'get_posts_'+this.loopId);
            data.append('blockId', this.loopId);

            console.log('get_posts_'+this.loopId);
            const postQuery = async () => {
                const response = await fetch(ajaxurl, {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: data
                });
                return response;
            }

            postQuery().then(data => {
                console.log(data.json());
            });
        }
    }))
});